import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import BrandMark from '@/components/BrandMark';
import BrandTagline from '@/components/BrandTagline';
import BrandWord from '@/components/BrandWord';

type State = {
  termsVersion?: string;
  termsAcceptedAt?: string;
};

function formatAcceptedAt(value: string | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString();
}

export default function RegistrationConfirmed() {
  const location = useLocation();
  const state = (location.state ?? {}) as State;

  return (
    <div className="login-page">
      <div className="login-bg" aria-hidden />
      <div className="login-panel">
        <div className="login-brand">
          <BrandMark size="large" />
          <h1><BrandWord /></h1>
          <BrandTagline className="brand-tag login-brand-tag" />
        </div>

        <div className="login-card card card-elevated">
          <h2>Request received</h2>
          <p>
            Your account request has been received and is waiting for review by a Scoutly administrator. We will email
            you when your request is approved or rejected.
          </p>
          <p className="muted">
            Terms and Conditions accepted: version <strong>{state.termsVersion ?? '—'}</strong> on{' '}
            <strong>{formatAcceptedAt(state.termsAcceptedAt)}</strong>.
          </p>
          <div className="registration-confirmed-actions">
            <Link className="btn btn-ghost" to="/register">
              Back
            </Link>
            <Link className="btn btn-primary" to="/login">
              Go to sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
